import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchOwnExtraService', request, cancelToken)
}

export {get}
